/** Page not found copy. EN mirrors SV until proper translations are added. */
export const pageNotFoundTranslationsSv = {
    title: '404 - Sidan kunde inte hittas',
    message: 'Sidan du försökte nå kunde inte hittas.',
}
